module.exports = {"520115001":"宾阳街道","520115002":"云潭街道","520115003":"金华园街道","520115004":"长岭街道","520115005":"观山街道","520115006":"世纪城街道","520115007":"金阳街道","520115100":"金华镇","520115101":"朱昌镇","520115102":"百花湖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520115.json
// module id = 2584
// module chunks = 0